import { render } from "./admissionManager.vue?vue&type=template&id=5dc6653f"
import script from "./admissionManager.vue?vue&type=script&lang=js"
export * from "./admissionManager.vue?vue&type=script&lang=js"

import "./admissionManager.vue?vue&type=style&index=0&id=5dc6653f&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__